import { Navigate } from "react-router-dom";

// Compatibility route (Phase 4): the old onboarding wizard (store details + quotation + payment) is retired. Onboarding lives in the
// dashboard (Store-based) and the subscription / payment in its subscription section. Old bookmarks and e-mail links land there.
const StoreOnboardingPage = () => <Navigate to="/auth/lud-dashboard" replace />;

export default StoreOnboardingPage;
